export default {
    'translation': {
        // 'Common': {
        //
        // },
        // 'ServiceUser': {
        //     'Auth': {
        //         'insert_security_code' : 'Insert the security code en'
        //     }
        // },

        // 소비자 앱
        'insert_security_code' : 'Insert the security code',
        'valid_security_code' : 'This is a valid approval code. (Authentication count: {{count}})',
        'security_code' : 'security code',
        'confirm': 'Confirm',
        'expired_authentication': 'This product has expired authentication',
        'product_not_exist': 'This product does not exist',
        'product_not_exist_detail': 'Please try to authenticate again or contact the manufacturer',
        'contact_customer_center': 'Please contact the customer center\n for further details.',
        'authenticating': 'Authenticating',
        'wait_moment': 'Please, wait a moment',
        'authentication_result': 'Authentication result',
        'authenticated': 'Authenticated',
        'manufacturer': 'Brand',
        'distribution_details': 'Distribution acquisition details',
        'scan_list': 'Scan list',
        'product_detail': 'Detail',
        'distribution_history': 'Distribution history',
        'hash_tags': 'Hash Tag',
        'shop_tags': "Store URL",
        'company_tags': "Company Website",
        'no_hashtags': "No hashtags specified.",
        'no_shopurl': "No store URL available.",
        'no_companyurl': "No company URL available.",
        'has_event': ' has an event!',
        'app_benefit_1': 'After you install the M-Check APP and authenticate the product,',
        'app_benefit_2': 'You can get many benefits.',
        'app_benefit_3': 'Install the app and participate in the event!',
        'download_app': 'Download the M-Check APP',
        'view_on_web': 'View pages on the Web',
        'incorrect_code': 'Incorrect code',
        'cant_find_code': "We can't authenticate the code",
        'check_code_again': "Please, check the product code again",
        'inserted_code': "Security code inserted",
        'contact_customer_center_error': "If re-authentication is confirmed as an Incorrect code,\n please contact the place of purchase or customer center.",
        'select_product_place': "Please, choose where you purchased your product",
        'to_improve_service': "This survey is intended to be used as a resource\n to improve product and service problems.",
        'submit_survey': "Submit the survey",
        'touch_object': "The movie will play when you touch the 3D object",
        'scan_qr_code': "Please, scan the QR code",
        'no_authentication': "No result for authentication",
        'welcome': "Welcome",
        'login_benefit': "There are a number of benefits for customers who are logged in.",
        'facebook_login': "Facebook Login",
        'line_login': "Line Login",
        'weibo_login': "Weibo Login",
        'close': "close",
        'product_code': "Product code",
        'product_info': "Product info",
        'authenticationi_list': "Authenticationi list",
        'events_you_won': "Events you won",
        'sorry': "I am sorry",
        'once_per_id': "Only once per ID is allowed to participate in the event.",
        'ok': "OK",
        'closed_event': "Event closed",
        'wait_for_next_event': "The next event will come soon.",
        'lotto_void_message': 'Next time',
        'event_result': "Result",
        'find_in_authentication_detail': "The promotion bar code for the event winning details can be found in the authentication details..",
        'you_win': "You win!",
        'turn_roulette': "Turn it around, Roulette!",
        'scratch_lotto': "Please, scrape the lottery",
        'sns_login': "SNS Login",
        'login_required_for_event': "SNS login is required to participate in the event.",
        'turn_on_light': "Turn on the light\n in the dark.",
        'scan_qr_or_tag_nfc': "Scan QR code or tag\n in NFC mode to activate.",
        'check_3d_modeling': "Check the 3D modeling of the product\n through AR scan!",
        'check_through_authentication': "Check product info and details\n through the authentication.",
        'check_first_authentication': "Check out\n the first authentication!",
        'check_the_way_distributed': "Check the history\n which this product was distributed.",
        'scroll_to_check_detail': "Scroll down\n to check product details!",
        'participate_for_benefit': "Participate in an event\n and get special benefits!",
        'log_in': "Log in",
        'register': "Register",


        // CMS
        'id': "ID",
        'password': "Password",
        'enter_id': "Enter the ID",
        'enter_password': "Enter the Password",
        'company_login': "Company Login",
        'admin_login': "ADMIN Login",
        'statistics': "Statistics",
        'member_management': "Members",
        'product_management': "Products",
        'track_trace_management': "Track&Trace",
        'operation_management': "Operation",
        'issue_codes': "Issue Codes",
        'statistics_overview': "OVERVIEW",
        'statistics_by_manufacturer': "Statistics by Brand",
        'statistics_by_products': "Statistics by Products",
        'by_manufacturer': "Brand",
        'by_distributor': "Distributor",
        'by_customer': "Customer",
        'company_info': "Company Info",
        'product': "Product",
        'event': "Event",
        'event_management': "Event",
        'track_trace': "Track&Trace",
        'abnormal_authentication': "Abnormal authentication",
        'abnormal_location': "Purchase location of abnormal authentication",
        'admin_member': "ADMIN member",
        'push_message': "PUSH message",
        'recent_year': "Statistics for last one year",
        'total_manufacturer': "Total # of Brand",
        'total_product': "Total # of product group",
        'total_tags': "Total # of issued tags",
        'total_authentication': "Total # of authentication",
        'top5_by_country': "TOP5 #of authentication by Country",
        'top5_by_product': "TOP5 #of authentication by Product",
        'country_name': "Country name",
        'authentication_rate': "rate of authentication",
        'product_name': "Product name",
        'statistics_by_map': "Statitics by Map",

        'register_company': "Register",
        'company_search_keyword': "Name/Company#/ID",
        'search': "Search",
        'total': "Total",
        'selected_member_status': "Selected member status",
        'change': "Change",
        'normal': "normal",
        'block': "block",
        'select': "Select",
        'country': "Country",
        'company_logo': "Logo",
        'company_name': "Company",
        'ID': "ID",
        'member_in_charge': "Member in charge",
        'status': "Status",
        'registered_date': "Registered date",
        'register_distributor': "Register",
        'distributor_search_keyword': "Name/ID",
        'affiliate': "Affiliate",
        'customer_search_keyword': "Country/Name/ID",
        'customer_name': "Name",
        'customer_center': "Customer Center",
        'company_register': "Register Company",
        'company': "Company",
        'company_code': "Company code",
        'address': "Address",
        'contact': "contact",
        'person_in_charge': "Person in charge",
        'contact_number': "Contact number",
        'brand_logo': "Brand Logo",
        'upload_file': "Upload File",
        'preview': "Preview",
        'recommended_image_size': "recommended image size: 1080px*216px / 0.5MB maximum, .png, .gif, .svg transparent background",
        'business_license': "Certificate of Business license",
        'bank_account_copy': "Bank account copy",
        'telephone': "TEL",
        'operation_time': "Operation time",
        'edit': "Edit",
        'distributor': "Distributor",
        'product_list': "list of products",
        'product_number': "product #",
        'number_of_authentication': "number of authentication",
        'contacts': "Contacts",
        'select_affiliate': "Select a company",
        // 'select_affiliate': "Select a company",
        'distributor_info': "Distributor Info",
        'name': "Name",
        'person_in_charge_affiliate': "Person in charge of Affiliate",
        'manufacturing_date': "Manufacturing date",
        'authentication_location': "Authentication location",
        'authentication_date': "Authentication date",
        'authentication_history': "Authentication history",
        'attached_events': "Attached events",
        'customer_info': "Customer Info",
        'email': "Email",
        'gender': "Gender",
        'birth_year': "Birth year",
        'event_type': "Event Type",
        'event_name': "Event Name",
        'items': "items",

        'unauthorized': "Unauthorized",
        'approval': "Approval",
        'stop': "Stop",
        'expiration': "Expired",
        'request': "Request for approval",
        'product_register': "Register",
        'product_search_keyword': "Company/Product#/Product Name",
        'selected_product_status': "Status of the selected product",
        'design_settings': "Design settings",
        'set_language_as_default': "Set language as default page",
        'representative_image': "Representative Image",
        //// 신규 추가
        'admin_product_product_name_placeholder': 'Search Product Name',
        'admin_product_add_image_box': `Add<br/>Image`,
        'admin_product_hashtag_placeholder': `#Hashtag`,
        'admin_product_authentication_placeholder': `Number of authentications (max. 40 characters)`,
        'admin_product_3d_model_placeholder': `File size 20MB or less (.glb)`,
        'admin_product_bgm_placeholder': `File size 2MB or less (.mp3, .acc)`,
        'admin_product_video_placeholder': `Movie file size &lt;50 MB (.avi,.mp4)`,
        ////////////
        'add_image': "Add Image",
        'add_image_br': "Add\nImage",
        'recommended_representative_images': "Recommended Specifications for Representative Images : 1080px*786px, image size less than or equal to 0.5MB\n Up to 10 inputs",
        'detailed_information': "Detailed information",
        'recommended_detailed_image': "Recommended specification for detailed image: 1080px across, image size less than or equal to 0.5MB",
        'tag': "Tag",
        'authentication_information': "Authentication Information",
        'maximum_number_of_authentication': "Maximum number of authentication",
        'regardless_number_of_authentication': "-1 will continue to be authenticated regardless of the number of authentications.",
        'magnetic_authentication_guide': "Magnetic Authentication Guide",
        'connection_url': "Connection URL",
        'authentication_period': "authentication period",
        'start_date': "Start date",
        'expiration_date': "Expiration date",
        '3d_model': "3D Model",
        'recommended_file_size': "File size 20MB or less (.3dm, 3.3ds, CATpart, igs, .MODEL, .obj)",
        'video': "Video",
        'edit_feedback': "Edit Feedback",
        'survey_title': "Survey Title",
        'survey_contents': "Survey Contents",
        'survey_item': "Survey Item",
        'input': "Input",

        'authentication_stage': "Authentication Stage",
        'genuine_mark': "Genuine Mark",
        'layout': "Layout",
        'authentication_stage_design': "Authentication Stage Design",
        'add_design': "Add Design",
        'remove': "Remove",
        'register_product': "Register Product",
        'setting_product_permissions': "Setting Product Permissions",
        'basic_authentication': "Basic Authentication",
        'ar': "AR",
        'survey': "Survey",
        'lottery': "Lottery",
        'roulette': "Roulette",
        'sample_product_qr_code': "Sample Product QR Code",
        'download_qr': "Download QR",
        'copy_qr_link': "Copy QR Link",
        'image_recommendation_specification': "Image Recommendation Specification: 600px*144px / 0.5MB or less.png,.gif,.svg background transparent",
        'genuine_mark_design': "Genuine Mark Design",
        'register_event': "Register",
        'event_search_keyword': "Company/Product#/Product Name",
        'selected_event_status': "Status of the selected event",
        'type': "Type",
        'event_information': "Event Info",
        'event_image': "Event Image",

        'attach_event_image': "Please attach an event image.",
        'enter_url': "Enter URL",

        'event_image_specification': "Image specification 1080px*1920px, file size less than or equal to 0.5MB",
        'event_link': "Event Link",
        'event_info': "Event Info",
        'event_period': "Event Period",
        'time': "Time",
        'event_title': "Event Title",
        'maximum_15_characters': "Maximum of 15 characters with space",
        'maximum_21_characters': "Maximum of 21 characters with space",
        'number_of_goods': "the number of goods",
        'two_divisions': "two divisions",
        'three_divisions': "three divisions",
        'quadrant': "quadrant",
        'five_divisions': "five divisions",
        'six_divisions': "six divisions",
        'product_type': "Product type",
        'prize_name': "Product name",
        'product_description': "Product description",
        'maximum_byte': "18 byte maximum",
        'probability': "Probability",
        'acceptable_probability': "0.001% - 99% acceptable",
        'commodity_quantity': "Commodity Quantity",
        'change_to_zero_probability': "Change to zero probability on exhaustion",
        'promotion_code': "Promotion code",
        'promotion_code_or_barcode': "Production code/bar code\n Only 1 can be registered",
        'barcode_image': "Barcode image",
        'fail': "Fail",
        'image': "Image",
        'text': "Text",
        'prize_image_specification': "(Specification 480px*318px) File capacity 0.5 MB",

        'period': "Period",
        'specifying_distributor': "Specifying a distributor",
        'download_excel': "Download Excel file",
        'product_group': "Product group",
        'quantity': "Quantity",
        'select_product': "Selecting a Product",
        'register_manufacturing_sites': "Registration of manufacturing sites",
        'optional': "Optional",
        'add': "Add",
        'search_address': "Search Address",
        'setting_authentication_period': "Setting the authentication period",
        'specifying_authentication_zone': "Specifying of authentication zone",
        'view_map': "View Map",
        'undesignated': "Undesignated",
        'cut_off': "Block",
        'many_positions': "Many positions",
        'a_number_of_authentications': "a number of authentications",
        'abnormal_authentication_statistics': "Abnormal Authentication Statistics",
        'place_of_purchase': "Place of purchase",
        'register_admin': "Register Admin",
        'authorization': "Authorization",
        'member_level': "Member level",
        'completed': "Completed!",
        'message': "Message",
        'including_box_codes': "Including box codes",
        'individual_product': "Individual product",
        'automatic': "Automatic",
        'number_of_digits': "Number of digits",
        'manual': "Manual",
        'upload_excel_file': "Upload Excel file",
        'number_of_individual_products': "# of Individual product",
        'box_level': "BOX level",
        'box_ea': "BOX EA",
        'box_capacity': "capacity of\n BOX",
        'box_capacity_lv1': "capacity of\n BOX",

        'issue_codes_completed': "Completed",
        'issue_codes_failed': "Failed",
        'code_issue_info': "The Excel files are saved in each 500,000 codes.",

        'manufacturing_history': "Manufacturing history",
        'abnormal_authentication_history': "Abnormal authentication history",
        'number_of_authentications': "Number of authentications",
        'certifier': "Certifier",

        'max_number_of_authentications': "Number of authentications (max. 40 characters)",
        'recommended_music_file_size': "File size 2MB or less (.mp3, .acc)",
        'recommended_video_file_size': "Movie file size &lt;50 MB (.avi,.mp4)",




        // 유통자 앱
        'for_distributor': "For distributor",
        'forgot_password': "Forgot the password?",
        'contact_company': "Please, contact the company",
        'login': "Login",
        'hello': "Hello",
        'list_of_taking_over': "List of taking over",
        'none_of_list': "None of list",
        'and': "and",
        'select_unit': "Select the unit",
        'change_product_status': "Change the product status",
        'change_box_status': "Change the box status",
        'hand_over': "Hand Over",
        'take_over': "Take Over",
        'handover': "Handover",
        'takeover': "Takeover",
        'product_authentication': "Product Authentication",
        'box': "Box",
        'individual': "Individual product",
        'working_box_unit': "Working in box unit",
        'working_Individual_unit': "Working in individual product unit",
        'move_product': "Move Product",
        'move_product_to_another': "Move the product to another box",
        'insert_product': "Insert the product",
        'insert_product_to_this': "Insert the product to this box",
        'remove_product': "Remove the product",
        'remove_product_from_this': "Remove the product from this box",
        'move_box_to_another_level': "Move the box to another level box",
        'move_box_to_another_same_level': "Move the box to another same level box",
        'insert_box': "Insert the box",
        'insert_box_to_higher_level': "Insert the box to higher level box",
        'remove_lower_level_box': "Remove the lower level box",
        'remove_lower_level_box_from_this': "Remove the lower level box from this box",
        'cancel': "Cancel",
        'check': "Check",
        'complete': "Complete",
        'takeover_list': "Takeover list",
        'handover_list': "Handover list",
        'authentication_list': "Authentication list",
        'distributed_handover_details': "Distributed Handover Details",
        'distributed_takeover_details': "Distributed Takeover Details",
        'distributor_list': "Distributor List",


    }
}



























